import { render, staticRenderFns } from "./DefaultComponent.vue?vue&type=template&id=3da4e7aa&scoped=true"
import script from "./DefaultComponent.vue?vue&type=script&lang=js"
export * from "./DefaultComponent.vue?vue&type=script&lang=js"
import style0 from "./DefaultComponent.vue?vue&type=style&index=0&id=3da4e7aa&prod&lang=scss&scoped=true"
import style1 from "./DefaultComponent.vue?vue&type=style&index=1&id=3da4e7aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da4e7aa",
  null
  
)

export default component.exports